<template>
	<div
		class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-2"
	>
		<h2 class="text-2xl font-semibold text-gray-700 mb-6">
			{{ __("Ihre Tagespreise für den Standort") }} {{ userLocation.zip }}
			{{ userLocation.city }}
		</h2>

		<div class="flex-grow flex flex-col justify-center text-center">
			<div>
				<div v-if="loadingSpinner" class="inline-block grayscale">
					<ui-loading-spinner class="mx-auto" />
				</div>

				<p v-else
					class="border-2 border-white bg-white rounded-lg p-6 px-6 md:px-12 lg:px-24 mb-4 text-2xl font-medium inline-block max-w-4xl"
				>
					{{ __("priceticker_currently_no_prices_available") }}
				</p>
			</div>
		</div>

		<content-price-indications-info />
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		userLocation: {
			type: Object,
			default: null,
		},
		loadingSpinner: {
			type: Boolean
		}
	},
};
</script>
